import { render } from "./defaultTouchspin.vue?vue&type=template&id=0dd722cb"
import script from "./defaultTouchspin.vue?vue&type=script&lang=js"
export * from "./defaultTouchspin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__